import { fattPayClient } from "./FattPayClient";
import Payment from "./Payment";

export interface IPaymentProcessor
{
    tokenize(payment: Payment): Promise<Payment>;
}

export const paymentProcessor : IPaymentProcessor = fattPayClient;